const fullstoryID = "144CZP";

export { fullstoryID };
export default { fullstoryID };
